import { render, staticRenderFns } from "./show-tip.vue?vue&type=template&id=63afa4d4&"
import script from "./show-tip.vue?vue&type=script&lang=js&"
export * from "./show-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63afa4d4')) {
      api.createRecord('63afa4d4', component.options)
    } else {
      api.reload('63afa4d4', component.options)
    }
    module.hot.accept("./show-tip.vue?vue&type=template&id=63afa4d4&", function () {
      api.rerender('63afa4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/show-tip.vue"
export default component.exports